/**
 * UTC API/SQL timestamps rendered consistently for Korean operations.
 * A missing or invalid timestamp must not break the page.
 */
const dayFormatter=new Intl.DateTimeFormat('ko-KR',{timeZone:'Asia/Seoul',year:'numeric',month:'2-digit',day:'2-digit'});
const timeFormatter=new Intl.DateTimeFormat('ko-KR',{timeZone:'Asia/Seoul',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',hourCycle:'h23'});
export function formatWorkspaceDate(value:any, dateOnly=false, fallback='시각 미기록'):string {
    if(value===null || value===undefined || value==='')return fallback;
    if(typeof value!=='string' && typeof value!=='number' && Object.prototype.toString.call(value)!=='[object Date]')return fallback;
    let input=value;
    if(typeof input==='string') {
        input=input.trim().replace(/^(\d{4}-\d{2}-\d{2}) /,'$1T');
        if(!input)return fallback;
        if(/^\d{4}-\d{2}-\d{2}$/.test(input))input+='T00:00:00Z';
        else if(/^\d{4}-\d{2}-\d{2}T/.test(input) && !/(Z|[+-]\d{2}:?\d{2})$/i.test(input))input+='Z';
    }
    const date=new Date(input);
    if(!Number.isFinite(date.getTime()))return fallback;
    const parts=(dateOnly?dayFormatter:timeFormatter).formatToParts(date);
    const part=(type:string)=>parts.find(p=>p.type===type)?.value || '';
    const day=part('year')+'.'+part('month')+'.'+part('day');
    return dateOnly?day:day+' '+part('hour')+':'+part('minute');
}
